import React from 'react';
import { useHistory } from 'react-router-dom';
import css from './CreditsAsPackage.css';
import { useIsMobile } from '../../../../hooks/useIsMobile';
import { Button } from '../../../../components';
import { ConditionalWrapper } from '../../../../util/common';
import Carousel from '../../../../components/ListingCardsCarousel/Carousel';
import { Slide } from 'pure-react-carousel';
import { priceCards } from './priceCards';
import { IconSaleM } from '../../../../icons';
import { getUserCountry } from '../../../../util/location';
import config from '../../../../config';
import classNames from 'classnames';
import { createResourceLocatorString } from '../../../../util/routes';
import routeConfiguration from '../../../../routeConfiguration';
import { SEARCH_PARAM_PACKAGE_KEY } from '../../../BalancePage/BalancePage';
import { ReviewsWidget } from '../../../AuthenticationPage/ReviewsWidget';

const { supportedCountries } = config.maps;

export default () => {
    const history = useHistory();
    const [isMobile, _, computing] = useIsMobile(1024);

    const userCountry = getUserCountry();
    const { currency = 'CHF' } = supportedCountries[userCountry];

    const navigateToBalancePage = package_id =>
        history.push(
            createResourceLocatorString(
                'BalancePage',
                routeConfiguration(),
                {},
                { [SEARCH_PARAM_PACKAGE_KEY]: package_id }
            )
        );

    return computing ? null : (
        <section className={css.root}>
            <header>
                <h2 className={css.heading}>Credits als Paket</h2>
                <p className={css.description}>
                    Hol dir Credits im Vorteilspaket mit bis zu 45% Rabatt.
                </p>
            </header>
            <div className={css.holder}>
                <ConditionalWrapper
                    condition={isMobile}
                    wrapper={children => (
                        <Carousel
                            isMobile={isMobile}
                            items={children}
                            sliderClassName={css.slider}
                            sliderVisibleSlides={1}
                            hideButtonsOnEndStart
                            currentSlide={1}
                            rendererCarousel={(card, index) => (
                                <Slide index={index} key={index}>
                                    {card}
                                </Slide>
                            )}
                            rendererSingleItem={card => card}
                        />
                    )}
                >
                    {priceCards.map(({ id, label, creditsToPurchase, price, badge }, index) => (
                        <div
                            key={id}
                            className={classNames(css.card, {
                                [css.selected]: index === 1,
                            })}
                        >
                            <div className={css.selectedBadge}>Am beliebtesten</div>
                            <p className={css.cardLabel}>{label}</p>
                            <h3 className={css.cardDescription}>{creditsToPurchase} Credits</h3>
                            <div className={css.pricingSection}>
                                {badge && (
                                    <p className={css.cardBadge}>
                                        <IconSaleM />
                                        {badge}
                                    </p>
                                )}
                                <p className={css.cardPricing}>
                                    {currency} {price}
                                </p>
                            </div>
                            <Button type="button" onClick={() => navigateToBalancePage(id)}>
                                Credits kaufen
                            </Button>
                        </div>
                    ))}
                </ConditionalWrapper>
            </div>
            <ReviewsWidget className={css.reviewsWidget} />
        </section>
    );
};
